"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const context_1 = require("../context");
exports.useContentMappingDetailContext = () => {
    return react_1.useContext(context_1.ContentMappingDetailContext);
};
//# sourceMappingURL=useContentMappingDetailContext.js.map